import { useCallback, useEffect, useMemo, useState } from 'react';

import type { ChangeEventHandler, Dispatch, SetStateAction } from 'react';

type UseInputReturn = {
  input: {
    onChange: ChangeEventHandler<HTMLInputElement>;
    value: string;
  };
  setValue: Dispatch<SetStateAction<string>>;
};

const useInput = (initialValue: string = ''): UseInputReturn => {
  const [value, setValue] = useState<string>(initialValue);

  useEffect(() => {
    queueMicrotask(() => setValue(initialValue));
  }, [initialValue]);

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  return useMemo(
    () => ({
      input: {
        onChange: handleInputChange,
        value,
      },
      setValue,
    }),
    [value, handleInputChange],
  );
};

export { useInput, type UseInputReturn };
